type AppStoreConfig = {
  url?: string;
  appleID?: string | number;
} | null | undefined;

const PLACEHOLDER_APPLE_ID = /change\s+by\s+apple\s+id/i;

function readAppleId(value: unknown): string {
  const raw = String(value ?? '').trim();
  if (!raw || PLACEHOLDER_APPLE_ID.test(raw)) return '';

  const withoutPrefix = raw.replace(/^id/i, '').trim();
  if (/[a-z]/i.test(withoutPrefix)) return '';

  return withoutPrefix.replace(/\D/g, '');
}

/** Extrai o ID numérico da App Store. Ignora o placeholder "Change By Apple Id". */
export function extractAppleAppId(appStore: AppStoreConfig): string {
  if (!appStore) return '';

  const rawId = String(appStore.appleID ?? '').trim();
  if (PLACEHOLDER_APPLE_ID.test(rawId)) return '';

  const fromField = readAppleId(rawId);
  if (fromField) return fromField;
  if (rawId) return '';

  const url = appStore.url || '';
  if (PLACEHOLDER_APPLE_ID.test(url)) return '';
  return url.match(/\/id(\d+)/i)?.[1] || '';
}

/**
 * URL canônica da App Store (Brasil).
 * Só existe quando o appleID é numérico. O texto "Change By Apple Id" não conta.
 */
export function resolveAppStoreUrl(appStore: AppStoreConfig): string {
  const appleId = extractAppleAppId(appStore);
  if (!appleId) return '';
  return `https://apps.apple.com/br/app/id${appleId}`;
}

export function hasAppStoreLink(appStore: AppStoreConfig): boolean {
  return !!extractAppleAppId(appStore);
}
